module.exports = __webpack_public_path__ + "static/media/iadvize-color.2c27f290.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/iadvize-color.svg
// module id = 1123
// module chunks = 0